import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wishlist-card__image-wrap"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "wishlist-card__content" }
const _hoisted_7 = {
  key: 0,
  class: "wishlist-card__display-name"
}
const _hoisted_8 = {
  key: 1,
  class: "wishlist-card__finish-display-name"
}

import {ref} from 'vue';
import {WishlistItemDelete} from "Api/apis";
import {useStore} from "vuex";
import { useToast } from 'vue-toastification';

export default /*#__PURE__*/_defineComponent({
  props: {
	displayName: String,
	finishDisplayName: String,
	id: Number,
	itemsLength: Number,
	imageUrl: String,
	url: String,
},
  emits: ['itemDeleted'],
  setup(__props, { emit: emits }) {

const props = __props

const store = useStore();
const toast = useToast();
const componentName = 'WishlistCard';

const isLastItem = ref<boolean>(false);

const removeFromWishlist = async(id) => {
	let response = await WishlistItemDelete(id, store?.state?.authToken);
	if(!response.isErrors) {
		toast.success(`Item has been removed from your wishlist successfully`, {
			timeout: 2000,
		});
		if(props.itemsLength === 1) {
			isLastItem.value = true;
		}
		emits('itemDeleted', isLastItem.value);
	} else {
		toast.error(`An error occurred, please try again`, {
			timeout: 2000,
		});
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.url ? 'a' : 'div'), {
    href: __props.url,
    class: "wishlist-card"
  }, {
    default: _withCtx(() => [
      (__props.imageUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: __props.imageUrl,
              alt: `wishlist item image for ${__props.displayName}`,
              class: "wishlist-card__image"
            }, null, 8 /* PROPS */, _hoisted_2),
            _createElementVNode("span", {
              class: "wishlist-card__favorite-heart icon-whiteheart state-favorited",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (removeFromWishlist(__props.id)))
            }, _hoisted_5)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_6, [
        (__props.displayName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.displayName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.finishDisplayName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.finishDisplayName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["href"]))
}
}

})